<template>
  <ue-title type="caption" :text="item.id" weight="regular" color="grey-lighten-1" padding="x-2" margin="t-2"/>
  <div class="d-flex flex-column w-100" style="max-width: 300px;">
    <span class="text-body-1 text-primary text-uppercase font-weight-bold text-truncate px-2">
      {{ item?.content?.headline || $t('Please update the headline') }}
    </span>
  </div>

  <ue-configurable-card
    :title="item.name"
    style="background-color: transparent;"
    elevation="0"
    hide-separator
    align-center-columns
    :Xno-actions="$vuetify.display.mdAndDown"
    :col-ratios="$vuetify.display.mdAndUp ? [2, 1, 1, 1, 1] : [3, 1, 1, 1, 1]"
    mobile-breakpoint="sm"
    :items="[
      Object.entries(item.press_release_packages ?? item.pressReleasePackages ?? {}).reduce((acc, [key, value]) => {
        acc.push(value)
        return acc;
      }, []),
      item.content.date || (item.content.estimated_scheduled_at ? $d(item.content.estimated_scheduled_at, 'numeric') : 'N/A'),
      [
        item._price ?? 'N/A',
      ],
      [
        item._status ?? 'Draft'
      ],
      item.unread_chat_messages_for_you_count ?? 0,
    ]"
    :actions="[
      {
        name: 'edit',
        icon: 'mdi-pencil',
        color: 'primary'
      }
    ]"
  >
    <template #[`segment.1`]="segmentScope"
      >
      <div class="h-100 d-flex flex-column justify-center align-center">
        <div v-for="p in segmentScope.data" :key="`package-${p.id}`" class="w-100 d-flex">
          <div class="w-50">
            {{ p.packageable.name }}
          </div>
          <div class="w-50">
            {{ p.name }}
          </div>
        </div>
      </div>
    </template>
    <template #[`segment.2`]="segmentScope"
      >
      <div class="h-100 d-flex flex-wrap align-center justify-space-between">
        {{ segmentScope.data }}
      </div>
    </template>
    <template #[`segment.3`]="segmentScope"
      >
      <div class="h-100 d-flex flex-wrap align-center justify-space-between">
        <ue-dynamic-component-renderer :subject="item.state_formatted"/>
      </div>
    </template>
    <template #[`segment.4`]="segmentScope">
      <div class="h-100 d-flex flex-wrap align-center justify-space-between">
        <ue-dynamic-component-renderer v-if="!['in-review', 'draft', 'cancelled', 'rejected'].includes(item?.state?.code)" :subject="item.payment_status_formatted"/>
      </div>
    </template>
    <template #[`segment.5`]="segmentScope">
      <div class="h-100 d-flex flex-wrap align-center justify-space-between">
        <ue-recursive-stuff
          v-bind="handleFormatter(['chip', {color: 'warning', class: 'font-weight-black text-grey-lighten-6', variant: 'elevated', size: 'default'}], segmentScope.data)"
        />
      </div>
    </template>
    <template #[`segment.actions`]="segmentScope">
      <div>
        <div class="d-flex flex-wrap ga-2 justify-sm-end ml-n2 ml-md-0">
          <template v-for="(rowAction, k) in rowActions" :key="k">
            <v-tooltip v-if="itemHasAction(item, rowAction)"
              :text="$t( rowAction.label ?? $headline(rowAction.name) )"
              location="top"
              :disabled="rowAction.forceLabel ?? false"
              >
              <template v-slot:activator="{ props }">
                <v-btn
                  :text="rowAction.forceLabel ? $t( rowAction.label ?? $headline(rowAction.name) ) : null"
                  :variant="rowAction.variant ?? 'elevated'"
                  :density="rowAction.density ?? (rowAction.forceLabel ? 'comfortable' : 'compact')"
                  :size="rowAction.size ?? (rowAction.forceLabel ? 'default' : 'default')"
                  :icon="rowAction.forceLabel ? null : (rowAction.icon ? rowAction.icon : '$' + rowAction.name)"
                  :color="rowAction.color ?? 'primary'"
                  :rounded="rowAction.forceLabel ? null : true"
                  :class="rowAction.class ?? ''"
                  v-bind="{ ...props, ...rowAction.componentProps }"
                  @click="itemAction(item, rowAction)"
                />
              </template>
            </v-tooltip>
          </template>
        </div>
      </div>
    </template>
  </ue-configurable-card>
</template>

<script>
  import { useTableIterator, makeTableIteratorProps, tableIterableEmits } from '@/hooks/table'
  import { makeFormatterProps } from '@/hooks/useFormatter';

  const { ignoreFormatters } = makeFormatterProps()

  export default{
    emits: tableIterableEmits,
    props:{
      ...makeTableIteratorProps(),
      ignoreFormatters
    },
    setup(props, context){
      return {
        ...useTableIterator(props, context)
      }
    },
    computed: {
      languageFiles(){
        let pattern = /content\.(\d+)_content/
        return this.item.fileponds.filter(v => v.role.match(pattern))
      },
      languageFileNames(){
        return this.languageFiles.map(v => this.getFileName(v)).join(', ')
      },
      mediaFiles(){
        return this.item.fileponds.filter(v => v.role.match(/press_release_image/))
      },
      mediaFileNames(){
        return this.mediaFiles.map(v => this.getFileName(v)).join(', ')
      }
    },
    methods: {
      getFileName(filepond){
        const parts = filepond.file_name.split('.');
        const file_name = parts.slice(0, parts.length - 1).join('.');
        const extension = parts[parts.length - 1];
        return __shorten(file_name, 10) + '.' + extension;
      }
    },
    created(){
      // __log(this.item)
      // __log(JSON.stringify(this.item.fileponds))
      // console.log('ConfigurableCardIterator created', this.item, this.headers, this.iteratorOptions, this.rowActions)
    }

  }
</script>
